export default __webpack_public_path__ + "static/Logo Evergreen Brand – 1280px-507703a728d705c62d51facca84bf60d.jpg";